import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import CollectionItem from './CollectionItem';
import CollectionItemSkeleton from './CollectionItemSkeleton';

import './CollectionStyles.scss';

const LOAD_MORE_SKELETON_COUNT = 4;

const Collection = ({ title, items, children, onUpdateEntity, loading = false, skeletonCount = 12 }) => {
    const showInitialSkeletons = loading && items.length === 0;
    const showLoadMoreSkeletons = loading && items.length > 0;

    return (
        <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 }, textAlign: 'center' }}>
            <Box
              display="flex"
              alignItems="center"
              gap={2}
              mb={1}
              sx={{
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'center',
                textAlign: 'center',
                width: '100%'
              }}
            >
                <Typography
                    variant="h4"
                    className="collection-title"
                    sx={{ fontSize: { xs: '1.4rem', sm: '2rem' } }}
                >
                    {title}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        cursor: 'pointer',
                        color: 'primary.main',
                        textDecoration: 'underline',
                        fontSize: { xs: '0.9rem', sm: '1rem' }
                    }}
                >
                    {children}
                </Typography>
            </Box>

            <Box
              className="collection-grid"
              display="grid"
              gap={{ xs: 2, sm: 3 }}
              sx={{
                gridTemplateColumns: {
                  xs: 'repeat(auto-fill, minmax(200px, 1fr))',
                  sm: 'repeat(auto-fill, minmax(220px, 1fr))',
                  md: 'repeat(auto-fill, minmax(240px, 1fr))'
                },
                justifyItems: 'center'
              }}
            >
                {showInitialSkeletons
                    ? Array.from({ length: skeletonCount }, (_, i) => <CollectionItemSkeleton key={i} />)
                    : items.map((item, index) => (
                        <CollectionItem onUpdateEntity={onUpdateEntity} key={index} {...item} />
                    ))
                }
                {showLoadMoreSkeletons && Array.from({ length: LOAD_MORE_SKELETON_COUNT }, (_, i) => (
                    <CollectionItemSkeleton key={`more-${i}`} />
                ))}
            </Box>
        </Container>
    );
};

export default Collection;
